<template>
  <div class="word-select-input">
    <div v-for="(entry, index) in value" :key="index" class="word-row">
      <label>第 {{ index + 1 }} 空</label>
      <select :value="entry.content" :disabled="disabled" @change="update(index, $event.target.value)">
        <option value="">请选择候选词</option>
        <option v-for="option in options" :key="option.key" :value="option.key">{{ option.key }}. {{ option.content }}</option>
      </select>
    </div>
  </div>
</template>
<script>
export default { name: 'WordSelectQuestionInput', props: { value: { type: Array, default: () => [] }, options: { type: Array, default: () => [] }, disabled: { type: Boolean, default: false } }, methods: { update(index, content) { const next = this.value.map(item => ({ ...item })); next[index] = { ...(next[index] || { name: index + 1 }), content }; this.$emit('input', next) } } }
</script>
<style scoped lang="scss">@import '@/styles/tokens'; .word-select-input { display: grid; gap: 12px; } .word-row { display: grid; grid-template-columns: 110px minmax(0, 1fr); gap: 12px; align-items: center; } label { color: $color-text-secondary; font-size: 14px; font-weight: 700; } @media (max-width: 768px) { .word-row { grid-template-columns: 1fr; } }</style>
